import {useState} from 'react';

import {Container} from '@/modules/hotels/components/List/components/DropDown/components/Container';
import {Option} from '@/modules/hotels/components/List/components/DropDown/components/Option';
import {Options} from '@/modules/hotels/components/List/components/DropDown/components/Options';

type Props = {
  options: Array<any>;
  handleChange: (item: any) => void;
  selectedValue: string;
};

export const DropDown: React.FunctionComponent<Props> = ({
  options,
  handleChange,
  selectedValue,
}) => {
  const [focusedValue, setFocusedValue] = useState<string | null>(null);

  return (
    <Container>
      <Options>
        {options?.map((item) => (
          <Option
            key={item.value}
            onClick={() => handleChange(item)}
            onMouseEnter={() => setFocusedValue(item.value)}
            isSelected={item.value === selectedValue}
            isFocused={item.value === focusedValue}
            isDisabled={false}
          >
            {item.label}
          </Option>
        ))}
      </Options>
    </Container>
  );
};
